import { getHelloKlarityBookingLinkListByProviderId } from 'api/operation';
import { useCallback, useEffect, useState } from 'react';
import { IHelloKlarityBookingLink } from 'types/operation';

const useGetBookingLinks = (providerId: number): [IHelloKlarityBookingLink[] | undefined, boolean, string, (id: number) => void] => {
    const [data, setData] = useState<IHelloKlarityBookingLink[]>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fetch = useCallback(async (id: number) => {
        setLoading(true);

        try {
            const res = await getHelloKlarityBookingLinkListByProviderId(id);

            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                setError(res?.error);
            }
        } catch (e) {
            console.error(e);
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        if (providerId) {
            fetch(providerId);
        }
    }, [fetch, providerId]);

    return [data, loading, error, fetch];
};

export default useGetBookingLinks;
